import React from 'react'
import Navbar from '../inc/Navbar'
import { Link } from "react-router-dom";
import AddEnqueries from '../AddEnqueries';

function Enquiry() {
  return (
    <div>
        <Navbar/>
        <br/>
        <br/>
        <br />
            <br />
            <br />
               <div className='nadiacloth'>
                <div className="album py-1">
                    <div className="container mt-4">
                        <nav aria-label="breadcrumb">
                            <ol className="breadcrumb">
                                <li className="breadcrumb-item"><Link to="/" href="#">Home</Link></li>
                                <li className="breadcrumb-item active" aria-current="page">Enqueries</li>
                            </ol>
                        </nav>
                    </div>
                </div>
            </div>
            <br/>
            <AddEnqueries/>
            <br/>

    </div>
  )
}

export default Enquiry